import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsightsExplainAway = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 375,
	height: 373,
	fill: "none",
	viewBox: "0 0 375 373",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#C4C4C4",
				d: "M0 0h375v373H0z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#F5F5F5",
				d: "M0 0h375v373H0z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0058A3",
				d: "M134 13v32H87V13z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 294,
				height: 185,
				x: 120,
				y: -70,
				fill: "#0058A3",
				rx: 20
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 294,
				height: 185,
				x: 120,
				y: -70,
				stroke: "#fff",
				rx: 20
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 294,
				height: 118,
				x: 120,
				y: 127,
				fill: "#fff",
				rx: 20
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 98,
				height: 262,
				x: 10,
				y: -17,
				fill: "#0058A3",
				rx: 20
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 98,
				height: 262,
				x: 10,
				y: -17,
				stroke: "#fff",
				rx: 20
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 408,
				height: 238,
				x: -42,
				y: 255,
				fill: "#0058A3",
				rx: 20
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 408,
				height: 238,
				x: -42,
				y: 255,
				stroke: "#fff",
				rx: 20
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0058A3",
				d: "M251 245h52v10h-52z"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 188,
				cy: 186,
				r: 31,
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FFCD3F",
				fillRule: "evenodd",
				d: "M185.5 196v-7H184v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H182v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FFCD3F",
				d: "m188.5 183.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#DFDFDF",
				fillRule: "evenodd",
				d: "M293.5 172v-7H292v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H290v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#DFDFDF",
				d: "m296.5 159.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#DFDFDF",
				fillRule: "evenodd",
				d: "M332.5 214v-7H331v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H329v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#DFDFDF",
				d: "m335.5 201.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#DFDFDF",
				fillRule: "evenodd",
				d: "M253.5 214v-7H252v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H250v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#DFDFDF",
				d: "m256.5 201.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0058A3",
				d: "M108 155h12v52h-12z"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h375v373H0z"
		})
	}) })]
});
export default SvgInsightsExplainAway;
